module.exports = __webpack_public_path__ + "img/carrot.e26bd00b.svg";